import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { useApp } from "../contexts/AppContext";
import { FileDown } from "lucide-react";
import { quizIconColor, quizIconComponent, darkenHex } from "../lib/quizIcons";
import RichText from "../components/RichText";

export default function TrainList() {
  const navigate = useNavigate();
  const { t, lang } = useApp();
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  const [quizzes, setQuizzes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/quizzes", { params: { type: "training" } }).then((r) => {
      setQuizzes(r.data || []);
      setLoading(false);
    });
  }, []);

  return (
    <div className="max-w-5xl mx-auto px-6 md:px-10 pt-10 pb-20" data-testid="train-list-page">
      <RichText k="train_title" as="h1" className="font-fredoka text-4xl md:text-5xl font-bold text-[#0B1D3A] mb-8" />

      {loading ? (
        <p className="font-nunito text-[#0B1D3A]/60">{t("loading")}</p>
      ) : quizzes.length === 0 ? (
        <div className="rounded-3xl bg-white p-8 shadow-[0_12px_40px_-10px_rgba(11,29,58,0.1)] border border-[#0B1D3A]/5">
          <RichText k="train_empty" as="p" className="font-nunito text-[#0B1D3A]/70" />
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {quizzes.map((q, i) => {
            const Icon = quizIconComponent(q);
            const color = quizIconColor(q, i);
            return (
            <div
              key={q.id}
              data-testid={`train-quiz-${q.id}`}
              className="group rounded-3xl bg-white p-6 border-2 border-[#0B1D3A]/5 hover:border-[#FF6B6B] transition-all shadow-[0_8px_30px_-12px_rgba(11,29,58,0.15)]"
            >
              <button onClick={() => navigate(`/play/training/${q.id}`)} className="w-full text-left" data-testid={`train-quiz-start-${q.id}`}>
                <div className="flex items-center gap-4">
                  <span className="inline-flex h-14 w-14 items-center justify-center rounded-2xl" style={{ background: color, boxShadow: `0 6px 0 ${darkenHex(color)}` }} data-testid={`train-quiz-icon-${q.id}`}>
                    <Icon className="text-white" strokeWidth={2.5} />
                  </span>
                  <div>
                    <h3 className="font-fredoka text-2xl font-bold text-[#0B1D3A]">
                      {lang === "en" ? q.name_en : (q.name_br || q.name_pt)}
                    </h3>
                    <p className="font-nunito text-sm text-[#0B1D3A]/60 mt-1">
                      {lang !== "en" ? "Toca para começar" : "Tap to start"}
                    </p>
                  </div>
                </div>
              </button>
              {q.pdf_path && (
                <a
                  href={`${backendUrl}/api/files/${q.pdf_path}`}
                  target="_blank"
                  rel="noreferrer"
                  data-testid={`train-quiz-pdf-${q.id}`}
                  className="mt-4 inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#005F73]/10 text-[#005F73] hover:bg-[#005F73]/20 font-bold text-sm transition-colors"
                >
                  <FileDown size={16} /> {lang !== "en" ? "Descarregar PDF da prova" : "Download quiz PDF"}
                </a>
              )}
            </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
